import { FieldState } from 'formstate';

import { ZonedDateTime, toZonedDateTime } from '@ms-rewards/date-lib';
import { I18NText } from '@api/ChallengeClient';

export const required = <T = string | number | boolean | Date | undefined>(
    error: string = 'commons.validation.fields.required'
) => {
    return (value: T) => {
        if (typeof value === 'number') {
            return isFinite(value) ? false : error;
        }

        return value ? false : error;
    };
};

export const allFieldsFilled = (fields: { [key: string]: FieldState<any> }) => {
    return Object.values(fields).reduce((acc, field) => {
        if (
            (field.error !== undefined && field.error !== null) ||
            !field.dirty ||
            !String(field.$)
        ) {
            acc = false;
        }
        return acc;
    }, true);
};

export const minLengthValidation = (value: string, length: number) => {
    const pattern = new RegExp(`^.{${length},}$`);
    return pattern.test(value);
};

export const numberValidation = (value: string) => /[\d]/.test(value);

export const whiteSpaceValidation = (value: string) => /\s/.test(value);

export const alphabeticalCharacterValidation = (value: string) =>
    /[a-z]|[A-Z]/.test(value);

export const atLeastOne = (message: string) => (val: any[]) =>
    !val.length && message;

export const positiveNumberValidation = () => {
    return (value: number | undefined) => {
        if (value !== undefined) {
            return value > 0 ? false : 'must be greater than 0';
        }
        return false;
    };
};

export const maxNumberValidation = (max: number) => {
    return (value: number | undefined) => {
        if (value !== undefined) {
            return value > max ? 'must be less than or equal to ' + max : false;
        }
        return false;
    };
};

export const futureDateValidation = () => {
    return (value: ZonedDateTime | undefined, timezone: string) => {
        const now = toZonedDateTime(new Date(), timezone).subMinutes(1);

        if (value?.isBefore(now)) {
            return 'Choose a date in the future';
        }

        return false;
    };
};

export const requiredI18n = (error: string = 'Marked fields are required') => {
    return (value: I18NText) => {
        for (const key in value) {
            if (value[key as keyof I18NText]) {
                return false;
            }
        }
        return error;
    };
};
